import { analyticsStore } from './sendAnalytics';
import { DataLayerEvent } from './types';

window.dataLayer = window.dataLayer || [];
const originalPush: (...args: DataLayerEvent[]) => number = window.dataLayer.push.bind(window.dataLayer);

const queuedEvents: DataLayerEvent[] = [];

window.dataLayer.push = (...args: DataLayerEvent[]): number => {
  const { enabled } = analyticsStore.getState();

  if (enabled) {
    while (queuedEvents.length > 0) {
      originalPush(queuedEvents.shift()!);
    }

    return originalPush(...args);
  }

  queuedEvents.push(...args);

  return queuedEvents.length;
};
